module.exports = {
	"AdUnit": {
		"ad_label": "Annonse"
	},
	"Article": {
		"by": "Av",
		"related_news": "Relaterte nyheter"
	},
	"ArticleShare": {
		"share_article": "Del artikkel"
	},
	"PopularVideos": {
		"most_viewed": "Mest sett"
	},
	"AuthorInfo": {
		"show_all": "Vis alt"
	},
	"BlogIndex": {
		"heading1": "Alle",
		"heading2": "blogger",
		"show_more": "Vis flere innlegg fra"
	},
	"CookieNotification": {
		"close": "Lukk"
	},
	"ContentMeta": {
		"all": "Alt",
		"goals": "Mål",
		"game": "Match",
		"summary": "Sammendrag",
		"highlight": "Høydepunkt",
		"coverage": "Reportasje",
		"studio": "Studio",
		"program": "Program",
		"top-list": "Toppliste",
		"interview": "Intervju",
		"live": "Live",
		"48hclip": " ",
		"vce-clip": " "
	},
	"EmbedPlayer": {
		"not_found": "404 - Siden ble ikke funnet"
	},
	"ExpandableBox": {
		"show_more": "Vis mer"
	},
	"FeedContainerBig": {
		"extra": "Extra",
		"top_news": "Siste nytt",
		"blog": "Blogg",
		"podcast": "Podcast"
	},
	"FbCommentBox": {
		"show_comments": "Vis kommentarer"
	},
	"FollowFacebook": {
		"heading": "Følg oss på Facebook",
		"social_blurb": "Hold deg oppdatert"
	},
	"FollowMail": {
		"email_label": "Skriv inn din e-postadresse",
		"heading": "Meld deg på vårt nyhetsbrev",
		"see_examples": "Se eksempler",
		"sign_up": "Meld deg på",
		"social_blurb": "Hold deg oppdatert",
		"viaplay_option_description": "Det siste om TV, film og sport",
		"viaplay_option_title": "Nyhetsbrev fra Viaplay",
		"viasport_option_description": "Sportsnyheter én gang i uken",
		"viasport_option_title": "Nyhetsbrev fra Viasat Sport"
	},
	"FollowTwitter": {
		"heading": "Følg oss på Twitter",
		"social_blurb": "Hold deg oppdatert"
	},
	"LeagueIndex": {
		"heading": "Ligaer"
	},
	"LeagueTables": {
		"result": "Resultater",
		"table": "Tabell"
	},
	"LiveScoreIndex": {
		"heading": "Livescore"
	},
	"LiveStreamListing": {
		"live": "Live!",
		"today": "I dag",
		"tomorrow": "I morgen"
	},
	"Login": {
		"forgot": "Glemt brukernavn eller passord?",
		"heading": "Logg inn",
		"login_button": "Logg inn",
		"login_w_fb": "Logg inn med din Facebook-konto",
		"or": "eller",
		"password": "Passord",
		"username": "Brukernavn",
		"email": "E-post",
		"coming_soon": "Et eget område for innloggede brukere kommer etter planen senere i år. Logger du deg inn vil du få tilgang til store mengder netteksklusivt sportsinnhold, helt gratis! Legg igjen din e-postadresse nedenfor, så vil vi holde deg oppdatert.",
		"notify_me": "Sende",
		"registration_complete": "E-post registrert!"
	},
	"Mail": {
		"email": "E-post"
	},
	"MobileNav": {
		"social_blurb": "Hold deg oppdatert"
	},
	"Modal": {
		"close": "Lukk"
	},
	"Navbar": {
		"video": "Video",
		"login": "Logg inn",
		"menu": "Meny",
		"popular_teams": "Populære lag",
		"popular_leagues": "Populære ligaer"
	},
	"NoMatch": {
		"heading": "404",
		"body": "We couldn't find the page you were looking for. You may have mistyped the address or the page may have been moved.",
		"viasport_startpage": "Return to the start page"
	},
	"Notifications": {
		"close": "Lukk",
		"country_warning": "Hei! Vi ser at du besøker siden vår fra et land utenfor Norge. Av rettighetsmessige årsaker kan det hende at noen videoer dessverre ikke er tilgjengelige for deg."
	},
	"PageHeading": {
		"news": "Nyheter"
	},
	"PodcastIndex": {
		"heading1": "Alle",
		"heading2": "Podcaster",
		"show_more": "Vis alle episoder av"
	},
	"Poll": {
		"button": "Stem",
		"error": "Noe gikk galt da stemmen skulle lagres."
	},
	"SearchForm": {
		"cancel": "Kansellere"
	},
	"SearchPage": {
		"results_for": "Søkeresultater for"
	},
	"Signup": {
		"heading": "Registrer deg",
		"login_button": "Logg inn",
		"or": "eller",
		"password": "Passord",
		"signup_w_fb": "Registrer deg med din Facebook-konto",
		"username": "Brukernavn"
	},
	"SocialArea": {
		"email": "E-post",
		"social_blurb": "Hold deg oppdatert"
	},
	"StoryNav": {
		"next": "Neste artikkel"
	},
	"TablesIndex": {
		"heading": "Tabeller"
	},
	"TeamIndex": {
		"heading": "Lag",
		"popular_teams": "Populære lag"
	},
	"TotalShares": {
		"total_shares": "Antall delinger"
	},
	"TvGuide": {
		"heading": "TV-guide"
	},
	"TwitterFollowWidget": {
		"follow": "Følg"
	},
	"UnsupportedBrowser": {
		"heading": "Oops, din nettleser er for gammel, og støttes ikke av viasport.no.",
		"body": "Viasport.no fungerer med en rekke ulike nettlesere. Du behøver derimot å oppgradere din nettleser slik at du sikker på at alt fungerer som det skal.",
		"meta": "Her har vi listet opp noen av de mest vanlige nettleserne vi støtter.",
		"close": "Lukk"
	},
	"UserArea": {
		"login": "Logg inn",
		"signup": "Registrer deg",
		"login_blurb": "Få tilgang til premium-innhold"
	},
	"ViaplayLiveFeed": {
		"text": "Se sport i verdensklasse, der du er (uansett hvor du er). Skaff Viaplay",
		"button": "Prøv Viaplay",
		"highlight_streams": "Hovedsendinger",
		"all_streams": "Alt",
		"link": "http://viaplay.no/sport",
		"linkText": "Andre sendinger på viaplay.no"
	},
	"VideoIndex": {
		"show_clip": "Vis klipp",
		"show_clips": "Vis alle",
		"show_clips_2": "klipp",
		"summary": "Alle sammendrag av",
		"clip": "klipp",
		"clips": "klipp",
		"heading": "Video",
		"no_events_for_date": "Ingen videoer på denne datoen",
		"no_events": "Det er ingen aktiviteter",
		"today": "i dag",
		"yesterday": "i går"
	},
	"VideoPlayer": {
		"watch_again": "Spill av videoen på nytt",
		"related_videos": "Relaterte klipp",
		"unsupported_browser": "Hello! Vi ser at du bruker en nettleser som vi ikke støtter. Hvis du vil fortsette å se anbefaler vi at du",
		"chrome_link_text": "laster ned nettleseren Google Chrome",
		"video_expired": "Beklager! Publiseringstiden til denne videoen utløp etter 48 timer og videoen er ikke lenger tilgjengelig"
	},
	"WidgetIndex": {
		"player_info": "Spillerinformasjon",
		"squad_stats": "Laginformasjon"
	},
	"InfiniteScroll": {
		"no_more_articles": "Du har nådd slutten av flyten."
	},
	"Premium": {
		"heading": "Premium"
	},
	"Thumbnail": {
		"playing": "Spiller nå"
	},
	"Feedback": {
		"widgetTitle": "Del dine tanker",
		"formTitle": "Totalvurdering",
		"message": "Hva kan vi gjøre bedre?",
		"name": "Navn",
		"email": "E-post (ingen spam)",
		"notify": "Er du interessert å motta informasjon om brukertesting ved vårt hovedkontor i Stockholm?",
		"close": "Lukk",
		"send": "Send"
	}
};


//////////////////
// WEBPACK FOOTER
// ./l10n/nb.json
// module id = 694
// module chunks = 6